import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhone, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import '../../../assets/css/customer/contact/ContactDetail.css';

const ContactDetail = () => {
  const contactInfo = [
    {
      id: 1,
      icon: <FaPhone />,
      title: 'Phone:',
      details: [
        '03441812760',
        
      ]
    },
    {
      id: 2,
      icon: <FaMapMarkerAlt />,
      title: 'Address:',
      details: [
        '121 King Street Melbourne,',
        '3000, Australia'
      ]
    },
    {
      id: 3,
      icon: <FaEnvelope />,
      title: 'Email:',
      details: [
        'support@bridely.com',
        'events@bridely.com'
      ]
    }
  ];

  return (
    <section className="contact-details-section">
      <Container>
        {/* Section Header */}
        <div className="contact-details-header">
          <p className="contact-details-label">Contact with Us</p>
          <h2 className="contact-details-heading">Contact Details</h2>
        </div>

        {/* Contact Cards */}
        <Row className="contact-details-row">
          {contactInfo.map((item, index) => (
            <Col key={item.id} lg={4} md={4} sm={12} className="contact-details-col">
              <div 
                className="contact-details-card"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                {/* Icon */}
                <div className="contact-details-icon">
                  {item.icon}
                </div>

                {/* Title */}
                <h3 className="contact-details-title">{item.title}</h3>

                {/* Details */}
                <div className="contact-details-info">
                  {item.details.map((detail, idx) => (
                    <p key={idx} className="contact-details-text">{detail}</p>
                  ))}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ContactDetail;